import { Box, Button, Grid, Typography } from '@material-ui/core';
import { ReactComponent as WelcomeImage } from 'assets/icon/startup.svg';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth, useProfile } from 'store/firebase/selectors';

import Logo from 'components/logo';
import useFormStyles from '../form.styles';
import FormBase from '../FormBase';
import './Start.css';

interface StartProps {
  onClickPrimary: () => void;
  onClickSecondary: () => void;
}

const Start: FC<StartProps> = ({ onClickPrimary, onClickSecondary }: StartProps) => {
  const classes = useFormStyles();
  const { t } = useTranslation();

  const auth = useAuth();
  const userProfile = useProfile();

  const currentUser = {
    email: auth.email,
    displayName: userProfile.displayName || auth.displayName || '',
    photoURL: auth.photoURL,
  };

  return (
    <FormBase>
      <div>
        <Typography variant="h6">
          {`${t('pages.dashboard.welcome')}
                ${currentUser.displayName && currentUser.displayName}`}
        </Typography>
        <Box m={1} />
        <Typography variant="h4">
          {t('pages.onBoarding.welcome.getStarted')}
          <Box
            bgcolor="primary.main"
            color="primary.contrastText"
            style={{
              height: 10,
              width: 10,
              borderRadius: 5,
              display: 'inline-block',
            }}
            marginLeft={1}
            component="span"
          />
        </Typography>
        <Box m={1} />
        <Box className={`levitate ${classes.welcomeContainer}`}>
          <Logo height="30px" />
          <WelcomeImage style={{ maxWidth: 250 }} className="levitate" />
        </Box>
        <Box m={1} />

        <Typography variant="body1" component="div">
          {t('pages.dashboard.detailsHeader')}
        </Typography>
        <Box m={1} />

        <Typography variant="caption">{t('pages.dashboard.details1')}</Typography>
      </div>
      <Box className={classes.btnDiv}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Button
              variant="outlined"
              color="default"
              onClick={() => onClickSecondary()}
              className={classes.btn_sec}
              fullWidth
            >
              {t('pages.onBoarding.backButton')}
            </Button>
          </Grid>
          <Grid item xs={12} md={6}>
            <Button
              className={classes.btn_pri}
              color="primary"
              fullWidth
              variant="contained"
              type="submit"
              onClick={() => onClickPrimary()}
            >
              {t('pages.onBoarding.forwardButton')}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </FormBase>
  );
};

export default Start;
